import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import SendDownLinkCommand from './components/SendDownLinkCommnad';
import { usePermission } from '@contexts/Auth/UsePermission';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import Page403 from '@page/Common/403/403';
const SendDownLink = () => {
  const { command } = usePermission();
  const navigate = useNavigate();

  return (
    <ContainerBody>
      {command.setBasic || command.setAdvanced || command.viewHistory ? (
        <>
          <div className="breadcrumb">
            <Breadcrumb homePath={'/dashboard'} routeSegments={[{ name: 'Quản lý gửi lệnh' }]} />
          </div>
          <SendDownLinkCommand />
        </>
      ) : (
        <Page403 />
      )}
    </ContainerBody>
  );
};
export default compose(withPaginate)(SendDownLink);
